module.exports = __webpack_public_path__ + "media/dashboard/assets/images/priority_icons/urgent-49e2b57b24b470ee5e32d732c37d4a9a.svg";